








































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import HomeIcons from '@/components/home/swiperIcons.vue'
import activeList from '@/components/home/activeList.vue'
import tabBar from '@/components/home/tabBar.vue'
import tabManagerBar from '@/components/home/manageBar.vue'
import estateWorkerBar from '@/components/home/manageBar.vue'

const activityManagementModule = namespace('activityManagement')
@Component({
  components: {
    HomeIcons,
    activeList,
    tabBar,
    tabManagerBar,
    estateWorkerBar
  }
})
export default class Home extends Vue {
  managerHomeShow: boolean = false
  estateWorkerShow: boolean = false
  finished: boolean = false
  loading: boolean = false
  all_menu: Array<any> = []
  loc_menu: Array<any> = []
  activityListPageLoading!: boolean
  topIcon: any = {
    list: [],
    num: 8
  }
  classIcon: any = {
    list: [],
    num: 4
  }
  pages: any = {
    pageNum: 1,
    pageSize: 50,
    totalPage: 0
  }
  activeList: any = []
  homeRouter: any = []
  tabActive: number = 0
  listLoading: boolean = false
  mounted() {
    console.log(this.$global.routes)
    this.managerHomeShow =
      (this.$global.routes &&
        this.$global.routes.indexOf('/manageHome') >= 0) ||
      this.$global.routes.indexOf('/estateWorker') >= 0
        ? true
        : false
    this.estateWorkerShow =
      this.$global.routes && this.$global.routes.indexOf('/estateWorker') >= 0
        ? true
        : false
    this.getPath()
    this.getActivityList()
  }
  getPath() {
    this.topIcon.list = [
      {
        path: '/couponVerification',
        imgUrl: require('../image/icon_1.png'),
        desc: '券码核销'
      },
      {
        path: '/faceCoupon',
        imgUrl: require('../image/icon_2.png'),
        desc: '面对面赠券'
      },
      {
        path: '/retreatCoupon',
        imgUrl: require('../image/icon_10.png'),
        desc: '扫码退券'
      },
      {
        path: '/coupon',
        imgUrl: require('../image/icon_3.png'),
        desc: '券管理',
        msg: '券管理(商户端)'
      },
      {
        path: '/activityManagement',
        imgUrl: require('../image/icon_4.png'),
        desc: '活动管理'
      },
      {
        path: '/couponCancel',
        imgUrl: require('../image/icon_5.png'),
        desc: '核销记录'
      },
      {
        path: '/coupon/audit',
        imgUrl: require('../image/icon_1.png'),
        desc: '券管理',
        msg: '券管理(商管端)'
      }
    ]
    this.classIcon.list = [
      {
        imgUrl: require('../image/icon_7.png'),
        path: '/reportSales',
        desc: '上报销售',
        text: '上报销售(商户端)'
      },
      {
        imgUrl: require('../image/icon_8.png'),
        path: '/estate',
        desc: '物业报修',
        text: '物业报修(商户端)'
      },
      {
        imgUrl: require('../image/icon_7.png'),
        path: '/reviewSales',
        desc: '上报销售',
        msg: '上报销售(商管端)'
      },
      {
        imgUrl: require('../image/icon_8.png'),
        path: '/estateManage',
        desc: '物业报修',
        msg: '物业报修(商管端)'
      },
      {
        imgUrl: require('../image/icon_8.png'),
        path: '/estateWorker',
        desc: '物业报修',
        text: '物业报修(维修工端)'
      }
    ]
    this.topIcon.list = this.filterPath(this.topIcon.list, this.$global.routes)
    this.classIcon.list = this.filterPath(
      this.classIcon.list,
      this.$global.routes
    )
  }
  getActivityList() {
    this.listLoading = true
    this.$store
      .dispatch('activityManagement/getActivityList', {
        pageNum: 1,
        pageSize: 5,
        isUsable: 1
      })
      .then(res => {
        this.listLoading = false
        if (res.success) {
          this.activeList = res.success.data.list
          this.activeList.map((item: any) => {
            let _item = item
            _item.activityStartDate = this.$format(
              _item.activityStartDate,
              'YYYY.MM.DD'
            )
            _item.activityEndDate = this.$format(
              _item.activityEndDate,
              'YYYY.MM.DD'
            )
            return _item
          })
        }
      })
  }
  filterPath(arr1: any, arr2: any) {
    return arr1.filter((item: any) => arr2.indexOf(item.path) >= 0)
  }
}
